import React from "react";
import { Layout } from "antd";
import { LoadRoutes } from "../components/General/LoadRoutes";
import { HeaderPublic } from "../components/Public/Header/HeaderPublic";
import { FooterGeneral } from "../components/Compartidos/FooterGeneral/FooterGeneral";
//Estilos css
import "../assets/css/Home.css";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";
import { linksRouter } from "../config/RouterLink";
import { willExpireToken } from "../helpers/refreshToken";
import { getUsuarioLogout } from "../redux/usuario/usuarioDucks";

/**
 * Layout que contiene la maquetación general de las pantallas públicas
 * @param {Props} props - routes: las rutas que se van a mostrar en el container
 * @return {JSX.Element} LayoutPublic
 */
export const LayoutPublic = (props) => {
  const dispatch = useDispatch();

  const { routes } = props;
  const { Content } = Layout;
  const { accessToken, autenticado, estatusAcceso } = useSelector(
    (state) => state.usuarioLogin
  );
  // const { estatusAcceso } = useSelector((state) => state.correo);

  window.scrollTo(0, 0); //Al inicio de la pantalla

  if (autenticado && estatusAcceso === "2") {
    dispatch(getUsuarioLogout());
    return (
      <>
        <Redirect to={linksRouter.cuentaDesactivada} />
      </>
    );
  }

  if (autenticado && estatusAcceso === "0") {
    return (
      <>
        <Redirect to={linksRouter.updateAdmin} />
      </>
    );
  }

  if (autenticado || !willExpireToken(accessToken)) {
    return (
      <>
        <Redirect to={linksRouter.home} />
      </>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#FFFFFF" }}>
      <HeaderPublic />
      <Content>
        {/* Componentes*/}
        <LoadRoutes routes={routes} />
      </Content>
      {/* <Footer version="versión 11.0" anio="2020" /> */}
      <FooterGeneral />
    </Layout>
  );
};
